// Actions
export const GET_NEXT_LIKES = 'GET_NEXT_LIKES'
export const GET_LIKE_DATA_FROM_REFERENCE = 'GET_LIKE_DATA_FROM_REFERENCE'
export const UPDATE_LIKES_DATES = 'UPDATE_LIKES_DATES'
export const MERGE_LIKE = 'MERGE_LIKE'
export const RESET_LIKES_ACTION = 'RESET_LIKES_ACTION'

// Mutations
export const UPDATE_LIKES_PUBLISHED_AT = 'UPDATE_LIKES_PUBLISHED_AT'
export const REFRESH_LIKES_PUBLISHED_AT = 'REFRESH_LIKES_PUBLISHED_AT'
export const ADD_LIKE_REF = 'ADD_LIKE_REF'
export const SET_LIKES_PUBLICATION = 'SET_LIKES_PUBLICATION'
export const UPDATE_LIKE_REF = 'UPDATE_LIKE_REF'
export const UPDATE_LIKES_DATA = 'UPDATE_LIKES_DATA'
export const MERGE_LIKE_DATA = 'MERGE_LIKE_DATA'
export const DELETE_LIKE = 'DELETE_LIKE'
export const DELETE_LIKE_REF = 'DELETE_LIKE_REF'
export const RESET_LIKES = 'RESET_LIKES'



// WEBPACK FOOTER //
// ./src/store/actions/favQueries.js